import type { JSONSchemaForXingletConfigFiles as XingletConfig } from './xinglet-schema';

type Permutations<T, U = T> = [T] extends [never]
  ? []
  : T extends T
    ? [T, ...Permutations<Exclude<U, T>>]
    : never;

export type ChunkMap = Record<string, string>;

export type ManifestScopes = Exclude<
  XingletConfig['manifestScopes'],
  undefined | '*'
>;

export type ManifestScope = ManifestScopes[number];

export const MANIFEST_SCOPES = Object.freeze<Permutations<ManifestScope>>([
  'crate',
  'brewery',
  'demo',
  'xing',
]);

export type Contributes = Exclude<XingletConfig['contributes'], undefined>;

export type Metadata = {
  dependencies: string[];
  frontmatters?: unknown[];
  contributes: Contributes;
  owner?: string;
  ssr: boolean;
};

export type Manifest = {
  id: string;
  entry: string;
  assets: string[];
  chunks: ChunkMap;
  metadata: Metadata;
  esm?: boolean;
};

export type ManifestMap = Record<string, Manifest>;

export type MetadataMap = Record<string, Metadata>;

export type PartialMetadataMap = Record<string, Partial<Metadata>>;
